module.exports = __webpack_public_path__ + "static/media/map-pin-cluster.85e3a68c.svg";